export const NotFoundPage = () => (
  <div
    className="flex items-center justify-center flex-col"
    style={{ minHeight: '320px' }}
  >
    <div className="font-bold text-zinc-800 text-6xl">
      4
      <span role="img" aria-label="Crying Face">
        😢
      </span>
      4
    </div>
    <p className=" text-zinc-800 leading-6 text-base">Page not found.</p>
  </div>
);
